document.addEventListener('DOMContentLoaded', () => {
  const dropdowns = document.querySelectorAll('.header-nav .dropdown');

  dropdowns.forEach(dropdown => {
    dropdown.addEventListener('mouseenter', () => {
      if (window.innerWidth > 1024) {
        document.body.classList.add('nav-hover');
      }
    });

    dropdown.addEventListener('mouseleave', () => {
      if (window.innerWidth > 1024) {
        document.body.classList.remove('nav-hover');
      }
    });
  });

  window.addEventListener('resize', () => {
    if (window.innerWidth <= 1024) {
      document.body.classList.remove('nav-hover');
    }
  });
});
